var _path, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankPayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.701 0.176011C11.0806 -0.0586427 11.5606 -0.0586978 11.9402 0.176011L22.0808 6.44945C23.0897 7.07373 22.6472 8.62914 21.4607 8.62914H20.2761V16.4963C21.2287 16.7769 21.9235 17.658 21.9236 18.7014C21.9236 19.9709 20.8943 21.0002 19.6248 21.0002H3.0154C1.74602 21.0001 0.716575 19.9708 0.716575 18.7014C0.716686 17.4321 1.74609 16.4027 3.0154 16.4026H3.07302V8.62914H1.18044C-0.00609578 8.62914 -0.448721 7.07367 0.560325 6.44945L10.701 0.176011ZM6.13747 16.4026H7.78591V8.62914H6.13747V16.4026ZM10.8504 16.4026H12.4988V8.62914H10.8504V16.4026ZM15.5633 16.4026H17.2117V8.62914H15.5633V16.4026Z",
    fill: "url(#paint0_linear_2818_2179)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 13 3.00781)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2818_2179",
    x1: 11.3205,
    y1: 21.0002,
    x2: 11.3205,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C40A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474DE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankPayment);
export default __webpack_public_path__ + "static/media/BANK_PAYMENT.7b6dfd2f957b7c054d64f6b8c9dcb13f.svg";
export { ForwardRef as ReactComponent };